<script setup lang="ts">
import { ZapIcon } from '@lucide/vue'

type Props = {
  isShrunk?: boolean
  isMobile?: boolean
}

defineProps<Props>()
</script>

<template>
  <button
    type="button"
    title="Power mode is on"
    class="flex items-center rounded-full bg-warning-subtle border border-warning/40 text-warning-subtle-foreground text-[13px] font-bold whitespace-nowrap cursor-pointer select-none"
    :class="isShrunk || isMobile ? 'shrink-0 justify-center size-8' : 'h-8 gap-1.5 pr-3 pl-2.5'"
  >
    <ZapIcon
      :class="isMobile ? 'size-4' : 'size-3.5'"
      aria-hidden="true"
    />
    <span v-if="!isShrunk && !isMobile">Power mode</span>
  </button>
</template>
